export default {"src":"https://fishbrain.com/_next/static/media/southDakota.4a396336.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};